import { z } from 'zod';

export const ConsumerReceptionChecklistItemSchema = z.object({
  categoryKey: z.string().min(1),
  itemKey: z.string().min(1),
  status: z.string().min(1).nullable(),
  /** BR-SO-164: quantity-kind items (e.g. Calotas) carry a count instead of a status. */
  quantity: z.number().nullable(),
  notes: z.string().nullable(),
});
export type ConsumerReceptionChecklistItem = z.infer<typeof ConsumerReceptionChecklistItemSchema>;

export const ConsumerReceptionChecklistPhotoSchema = z.object({
  id: z.uuid(),
  url: z.string().min(1),
  kind: z.string().min(1),
  mediaType: z.enum(['IMAGE', 'VIDEO']).default('IMAGE'),
  contentType: z.string().min(1).nullable().default(null),
});
export type ConsumerReceptionChecklistPhoto = z.infer<typeof ConsumerReceptionChecklistPhotoSchema>;

export const ConsumerReceptionChecklistDecisionSchema = z.enum(['APPROVED', 'REJECTED']);
export type ConsumerReceptionChecklistDecision = z.infer<
  typeof ConsumerReceptionChecklistDecisionSchema
>;

export const ConsumerReceptionChecklistListItemSchema = z.object({
  receptionId: z.uuid(),
  tenantId: z.uuid(),
  partyId: z.uuid(),
  workshopName: z.string().min(1),
  vehiclePlate: z.string().nullable(),
  vehicleLabel: z.string().nullable(),
  awaitingCustomerApprovalAt: z.string().min(1),
});
export type ConsumerReceptionChecklistListItem = z.infer<
  typeof ConsumerReceptionChecklistListItemSchema
>;

export const ConsumerReceptionChecklistsResponseSchema = z.object({
  items: z.array(ConsumerReceptionChecklistListItemSchema),
});
export type ConsumerReceptionChecklistsResponse = z.infer<
  typeof ConsumerReceptionChecklistsResponseSchema
>;

export const ConsumerReceptionChecklistDetailSchema =
  ConsumerReceptionChecklistListItemSchema.extend({
    checklistItems: z.array(ConsumerReceptionChecklistItemSchema),
    termPlainText: z.string(),
    photos: z.array(ConsumerReceptionChecklistPhotoSchema),
    customerDecision: ConsumerReceptionChecklistDecisionSchema.nullable(),
  });
export type ConsumerReceptionChecklistDetail = z.infer<
  typeof ConsumerReceptionChecklistDetailSchema
>;

/** BR-SO-113 — accepting the term is implicit in the approve action; flag kept for UI intent. */
export const ConsumerReceptionChecklistApproveBodySchema = z.object({
  acceptedTerm: z.literal(true).optional(),
});
export type ConsumerReceptionChecklistApproveBody = z.infer<
  typeof ConsumerReceptionChecklistApproveBodySchema
>;

export const ConsumerReceptionChecklistRejectBodySchema = z.object({
  reason: z.string().trim().min(1).max(500),
});
export type ConsumerReceptionChecklistRejectBody = z.infer<
  typeof ConsumerReceptionChecklistRejectBodySchema
>;

export const ConsumerReceptionChecklistDecisionResponseSchema = z.object({
  receptionId: z.uuid(),
  customerDecision: ConsumerReceptionChecklistDecisionSchema,
});
export type ConsumerReceptionChecklistDecisionResponse = z.infer<
  typeof ConsumerReceptionChecklistDecisionResponseSchema
>;
